/**
 * Zustand store for the Shared Mailboxes tab.
 *
 * Monolith equivalents:
 *  - currentSharedMailboxData  (line ~59158)
 *  - smAvailableDomains        (line ~59190)
 *  - createSharedMailboxState  (line ~59193)
 *  - smStepNames               (line ~59204)
 */
import { create } from 'zustand';

export const SM_STEP_NAMES = {
  1: 'Select Business',
  2: 'Basic Information',
  3: 'Primary Email',
  4: 'Additional Emails',
  5: 'Permissions',
  6: 'Mailbox Options',
  7: 'Review',
};

const INITIAL_WIZARD = {
  currentStep: 1,
  completedSteps: [],
  selectedBusiness: '',
  name: '',
  displayName: '',
  ticketNumber: '',
  emailPrefix: '',
  emailDomain: '',
  proxyAddresses: [],   // [{ prefix, domain }]
  permissions: [],      // [{ upn, displayName, fullAccess, sendAs, sendOnBehalf }]
  enableArchive: false,
  enableLitigationHold: false,
};

export const useSharedMailboxStore = create((set) => ({
  // Search
  searchResults: null,         // null = pristine, [] = no results
  searchLoading: false,
  searchQuery: '',
  selectedBusiness: '',

  // Business units cache
  businessUnits: [],           // [{ name, dn }] from GET /api/ad-business-units
  businessUnitsLoaded: false,

  // Accepted domains cache
  acceptedDomains: [],         // string[]
  acceptedDomainsLoaded: false,

  // Currently viewed mailbox
  currentMailbox: null,        // full mailbox object from API

  // Details modal open state
  detailsOpen: false,

  // Add Permission modal open state
  addPermOpen: false,

  // Archive modal open state
  archiveOpen: false,

  // Create wizard open state
  wizardOpen: false,

  // Create wizard form state
  wizard: { ...INITIAL_WIZARD },

  // --- Actions ---

  setSearchQuery: (q) => set({ searchQuery: q }),
  setSelectedBusiness: (b) => set({ selectedBusiness: b }),
  setSearchLoading: (v) => set({ searchLoading: v }),
  setSearchResults: (results) => set({ searchResults: results }),

  setBusinessUnits: (units) => set({ businessUnits: units, businessUnitsLoaded: true }),
  setAcceptedDomains: (domains) => set({ acceptedDomains: domains, acceptedDomainsLoaded: true }),

  openDetails: (mailbox) => set({ currentMailbox: mailbox, detailsOpen: true }),
  closeDetails: () => set({ detailsOpen: false, currentMailbox: null }),
  refreshCurrentMailbox: (mailbox) => set({ currentMailbox: mailbox }),

  openAddPerm: () => set({ addPermOpen: true }),
  closeAddPerm: () => set({ addPermOpen: false }),

  openArchive: () => set({ archiveOpen: true }),
  closeArchive: () => set({ archiveOpen: false }),

  openWizard: () => set({ wizardOpen: true, wizard: { ...INITIAL_WIZARD } }),
  closeWizard: () => set({ wizardOpen: false }),

  updateWizard: (patch) => set((s) => ({ wizard: { ...s.wizard, ...patch } })),
  resetWizard: () => set({ wizard: { ...INITIAL_WIZARD } }),
}));
